import { Loader } from '@googlemaps/js-api-loader';
import { GoogleMapsOptions } from './google-maps-options';

export function activeGoogleMaps({ apiKey, domId, icon, zoom, lat, lng, info }: GoogleMapsOptions) {
  const loader = new Loader({ apiKey, version: 'weekly' });

  loader.load().then((google) => {
    const map = new google.maps.Map(document.getElementById(domId), {
      center: { lat, lng },
      zoom,
      mapTypeControl: true,
      zoomControl: true,
      scaleControl: true,
      mapTypeId: 'roadmap',
    });

    const marker = new google.maps.Marker({ position: { lat, lng }, map, icon });

    if (info) {
      const infoWindow = new google.maps.InfoWindow({ content: info });
      marker.addListener('click', () => infoWindow.open(map, marker));
    }
  });
}